import {
  AUTH_REQUEST,
  AUTH_GOOGLE_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_FORGOT_PASSWORD,
  AUTH_RESET_PASSWORD,
  AUTH_REFRESH_TOKEN,
  AUTH_LOGOUT,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  CHATBOT_CONVERSATION
} from "../actions/auth";
import { USER_REQUEST } from "../actions/user";
import axios from "axios";

const state = {
  token: localStorage.getItem("user-token") || "",
  user: {},
  status: "",
  email: "",
  hasLoadedOnce: false,
  accessToken: localStorage.getItem("access-token") || "",
  question: ""
};

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status
};

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST, user);
      axios
        .post(process.env.VUE_APP_API + "/login_check", user)
        .then(resp => {
          localStorage.setItem("user-token", resp.data.token);
          localStorage.setItem("user-refresh-token", resp.data.refresh_token);
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + resp.data.token;
          commit(AUTH_SUCCESS, resp.data.token);
          dispatch(USER_REQUEST);
          resolve(resp.data);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          // localStorage.removeItem("user-token");
          // localStorage.removeItem("user-refresh-token");
          reject(err);
        });
    });
  },
  [AUTH_GOOGLE_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
        commit(AUTH_GOOGLE_REQUEST); // Set loading state

        axios
            .post(process.env.VUE_APP_API + "/google-login", {
                id_token: payload.id_token,
            })
            .then((resp) => {
                // Save tokens in localStorage
                localStorage.setItem("user-token", resp.data.token);
                localStorage.setItem("user-refresh-token", resp.data.refresh_token);

                // Set the Authorization header for future requests
                axios.defaults.headers.common["Authorization"] = "Bearer " + resp.data.token;

                // Commit success state and token
                commit(AUTH_SUCCESS, resp.data.token);

                // Optionally fetch user info
                dispatch(USER_REQUEST);

                resolve(resp.data); // Resolve with response data
            })
            .catch((err) => {
                // Handle errors
                commit(AUTH_ERROR, err);
                reject(err); // Reject with error
            });
    });
  },
  [AUTH_FORGOT_PASSWORD]: ({ commit }, email) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_FORGOT_PASSWORD);
      axios
        .post(process.env.VUE_APP_API + "/forgot-password", email)
        .then(resp => {
          // commit(AUTH_SUCCESS, resp.data);
          resolve(resp.data);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          reject(err);
        });
    });
  },
  [AUTH_RESET_PASSWORD]: ({ commit }, { token, newPassword, retypeNewPassword }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_RESET_PASSWORD);
      axios
        .post(process.env.VUE_APP_API + `/reset-password/${token}`, {
          newPassword,
          retypeNewPassword
        })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          reject(err);
        });
    });
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem("user");
      localStorage.removeItem("user-token");
      localStorage.removeItem("user-refresh-token");
      localStorage.removeItem("access-token");
      resolve();
    });
  },
  [AUTH_REFRESH_TOKEN]: async ({ commit }) => {
    commit(AUTH_REFRESH_TOKEN);
    localStorage.removeItem("user-token");
    const refreshToken = localStorage.getItem("user-refresh-token");
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_API + `/token/refresh`, {
          refresh_token: refreshToken
        })
        .then(resp => {
          resolve(resp.data);
          localStorage.setItem("user-token", resp.data.token);
          localStorage.setItem("user-refresh-token", resp.data.refresh_token);
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + resp.data.token;
          commit(AUTH_SUCCESS, resp.data.token);

          return resp;
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          reject(err);
        });
    });
  },
  [CHANGE_PASSWORD_REQUEST]: ({ commit, state }, { currentPassword, newPassword }) => {
    return new Promise((resolve, reject) => {
      commit(CHANGE_PASSWORD_REQUEST);

      // Assuming your user object has a 'password' property
      if (state.user && state.user.password === currentPassword) {
        axios
          .post(process.env.VUE_APP_API + "/change_password", {
            currentPassword: currentPassword,
            newPassword: newPassword
          })
          .then(() => {
            commit(CHANGE_PASSWORD_SUCCESS);
            resolve();
          })
          .catch(error => {
            commit(CHANGE_PASSWORD_ERROR, error);
            reject(error);
          });
      } else {
        const error = new Error("Current password is incorrect");
        commit(CHANGE_PASSWORD_ERROR, error);
        reject(error);
      }
    });
  },
  [CHATBOT_CONVERSATION]: ({ commit }, question) => {
    return new Promise((resolve, reject) => {
      // Check if access token is present
      if (!question) {
        const error = new Error("question not found");
        reject(error);
        return;
      }
      commit(CHATBOT_CONVERSATION);
   
      // Make the API call
      axios.get(process.env.VUE_APP_API + `/chatbot`, {
        params: {
          user_question: question
        }
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
    });
  },
};

const mutations = {
  // [AUTH_REQUEST]: state => {
  //   state.status = "loading";
  // },
  [AUTH_REQUEST]: (state, user) => {
    state.user = user;
    state.status = "loading";
  },
  [AUTH_GOOGLE_REQUEST]: (state, user) => {
    state.user = user;
    state.status = "loading";
  },
  [AUTH_REFRESH_TOKEN]: state => {
    state.status = "loading";
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = "success";
    state.token = resp.token;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: state => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  [AUTH_FORGOT_PASSWORD]: (state, email) => {
    state.status = "forgot_password";
    state.email = email;
  },
  [AUTH_RESET_PASSWORD]: (state) => {
    state.hasLoadedOnce = true;

  },
  [AUTH_LOGOUT]: state => {
    state.token = "";
    state.accessToken = "";
  },
  [CHANGE_PASSWORD_REQUEST]: state => {
    state.status = "loading";
  },
  [CHANGE_PASSWORD_SUCCESS]: state => {
    state.status = "success";
  },
  [CHANGE_PASSWORD_ERROR]: state => {
    state.status = "error";
  },
  [CHATBOT_CONVERSATION]: (state, question) => {
    state.status = "loading";
    state.question = question;
},
};

export default {
  state,
  getters,
  actions,
  mutations
};
